export const questions = [
  {
    id: 1,
    question: "What is the difference between a gross lease and a net lease?",
    options: [
      "Gross lease includes operating expenses, while net lease excludes them",
      "Gross lease excludes operating expenses, while net lease includes them",
      "Gross lease is for residential properties, while net lease is for commercial properties",
      "Gross lease is for commercial properties, while net lease is for residential properties",
      "There is no difference between the two",
    ],
    correctAnswer: "Gross lease includes operating expenses, while net lease excludes them",
  },
  {
    id: 2,
    question: "What is the Internal Rate of Return (IRR)?",
    options: [
      "The interest rate at which a property's net present value is zero",
      "The rate of return an investor needs to cover the costs of a property",
      "The difference between the capitalization rate and the discount rate",
      "The annual income generated by a property divided by its initial cost",
      "The amount of profit an investor expects to earn on a property",
    ],
    correctAnswer: "The interest rate at which a property's net present value is zero",
  },
  {
    id: 3,
    question: "What is a sale-leaseback transaction?",
    options: [
    "A transaction in which the owner sells the property and then leases it back",
    "A transaction in which the owner leases the property before selling it",
    "A transaction in which a tenant buys a property and then leases it",
    "A transaction in which the owner sells the property and the buyer leases it",
    "A transaction in which a property is sold and then leased by a third party",
    ],
    correctAnswer: "A transaction in which the owner sells the property and then leases it back",
    },
    {
    id: 4,
    question: "What is a tenant improvement allowance?",
    options: [
    "The amount a landlord contributes towards a tenant's moving expenses",
    "The amount a landlord contributes towards a tenant's utility costs",
    "The amount a landlord contributes towards a tenant's security deposit",
    "The amount a landlord contributes towards a tenant's insurance premiums",
    "The amount a landlord contributes towards a tenant's build-out or space improvements",
    ],
    correctAnswer: "The amount a landlord contributes towards a tenant's build-out or space improvements",
    },
    {
    id: 5,
    question: "What is a mortgage?",
    options: [
    "A type of lease agreement",
    "A document that grants ownership of real property",
    "A loan to purchase real property",
    "A fee paid to a real estate agent",
    "A tax on the sale of real property",
    ],
    correctAnswer: "A loan to purchase real property",
    },
    {
    id: 6,
    question: "What is a leasehold estate?",
    options: [
    "A type of ownership interest in real property",
    "An agreement to lease personal property",
    "An agreement to lease real property",
    "A tax on the rental of real property",
    "A fee paid to a property manager",
    ],
    correctAnswer: "An agreement to lease real property",
    },
    {
    id: 7,
    question: "What is the difference between a lease and a rental agreement?",
    options: [
    "There is no difference",
    "A lease is for a longer period of time than a rental agreement",
    "A rental agreement is for a longer period of time than a lease",
    "A lease includes the option to buy the property, a rental agreement does not",
    "A rental agreement includes the option to buy the property, a lease does not",
    ],
    correctAnswer: "A lease is for a longer period of time than a rental agreement",
    },
    {
      id: 8,
      question: "What is the difference between equity and debt financing for commercial real estate investments?",
      options: [
        "Equity financing involves borrowing money, while debt financing involves investing capital",
        "Equity financing involves selling ownership stakes in a property, while debt financing involves taking out loans",
        "Equity financing involves investing capital, while debt financing involves borrowing money",
        "Equity financing involves leasing a property, while debt financing involves buying it outright",
        "There is no difference between the two",
      ],
      correctAnswer: "Equity financing involves selling ownership stakes in a property, while debt financing involves taking out loans",
    },
    {
      "id": 9,
      "question": "What is the capitalization rate in real estate?",
      "options": [
        "The ratio of net operating income to property asset value",
        "The total cost of constructing a property, including both material and labor costs",
        "The process of estimating the value of a property",
        "The total income that a property generates in a year",
        "The interest rate of a mortgage"
      ],
      "correctAnswer": "The ratio of net operating income to property asset value"
    },
    {
      "id": 10,
      "question": "Which of these is considered a Class A property?",
      "options": [
        "Older property located in less desirable area",
        "Property that requires extensive renovation",
        "Newer property located in a prime urban location, with high quality construction and management",
        "All commercial real estate is classified as Class A",
        "Properties that are typically targeted by investors"
      ],
      "correctAnswer": "Newer property located in a prime urban location, with high quality construction and management"
    },
    {
      "id": 11,
      "question": "What is a triple net lease?",
      "options": [
        "A lease in which the tenant is responsible for all property related risks",
        "A lease where the rent includes one net of the three nets--property taxes, insurance, and maintenance",
        "A lease where the rent includes two nets of the three nets--property taxes, insurance, and maintenance",
        "A lease where the tenant is responsible for rent and utilities only",
        "A lease in which the landlord is responsible for all property related risks"
      ],
      "correctAnswer": "A lease in which the tenant is responsible for all property related risks"
    },
    {
      "id": 12,
      "question": "What is a commercial real estate 'walk-through'?",
      "options": [
        "The final inspection of a property before settlement or closing",
        "A virtual tour of a property online",
        "The process of getting a loan for a commercial real estate property",
        "A type of lease where the tenant pays for their proportionate share of the property taxes, insurance, and maintenance",
        "The process of determining the value of a property"
      ],
      "correctAnswer": "The final inspection of a property before settlement or closing"
    },
    {
      "id": 13,
      "question": "What is tenant improvement allowance?",
      "options": [
        "A sum of money granted by the landlord to help the tenant fit out or refurbish the rented space",
        "The amount of money a tenant must pay if they break their lease early",
        "The money a tenant must pay for maintenance and repairs",
        "The cost of utilities in a commercial building",
        "The amount a tenant must pay for rent"
      ],
      "correctAnswer": "A sum of money granted by the landlord to help the tenant fit out or refurbish the rented space"
    },
    {
      "id": 14,
      "question": "What is an anchor tenant in a commercial property?",
      "options": [
        "A tenant who lives in the property",
        "The largest tenant in a shopping center or mall",
        "A tenant who is late on rent",
        "A tenant who has signed a triple net lease",
        "A tenant who has a lease with a term of one year or less"
      ],
      "correctAnswer": "The largest tenant in a shopping center or mall"
    },
    {
      "id": 15,
      "question": "What does 'mixed-use' mean in commercial real estate?",
      "options": [
        "Properties that are used for both residential and commercial purposes",
        "Properties that are used for both retail and industrial purposes",
        "Properties that are used for both commercial and agricultural purposes",
        "Properties that are used for both residential and agricultural purposes",
        "All of the above"
      ],
      "correctAnswer": "Properties that are used for both residential and commercial purposes"
    },
    {
      "id": 16,
      "question": "What is a 'build to suit' lease?",
      "options": [
        "A lease in which the landlord builds a property to the tenant's specifications",
        "A lease in which the tenant builds the property and then rents it from the landlord",
        "A lease in which the tenant is responsible for all property-related expenses",
        "A lease in which the landlord is responsible for all property-related expenses",
        "A lease in which the tenant is responsible for property taxes, insurance, and maintenance"
      ],
      "correctAnswer": "A lease in which the landlord builds a property to the tenant's specifications"
    },
    {
      "id": 17,
      "question": "What does 'absorption rate' refer to in commercial real estate?",
      "options": [
        "The rate at which available properties in a specific real estate market are sold or rented",
        "The rate at which new properties are added to the market",
        "The rate at which property prices are increasing in a specific area",
        "The rate at which a property appreciates in value over time",
        "The rate at which mortgage interest rates are increasing"
      ],
      "correctAnswer": "The rate at which available properties in a specific real estate market are sold or rented"
    },
  // ... add the remaining 23 questions here
];